import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getDeviceScreenshotImage } from '@/api/device-screenshots';

interface ScreenshotImageProps {
  id: string;
  alt: string;
  className?: string;
}

/**
 * Картинка скриншота. Публичной ссылки у неё нет — байты тянутся через
 * авторизованный клиент и живут в object URL, поэтому это не просто <img src>.
 */
export function ScreenshotImage({ id, alt, className = '' }: ScreenshotImageProps) {
  const [src, setSrc] = useState('');
  const query = useQuery({
    queryKey: ['device-screenshot-image', id],
    queryFn: () => getDeviceScreenshotImage(id),
    staleTime: 10 * 60 * 1000,
  });

  useEffect(() => {
    if (!query.data) return;
    const next = URL.createObjectURL(query.data);
    setSrc(next);
    return () => URL.revokeObjectURL(next);
  }, [query.data]);

  if (query.isError) {
    return (
      <div className={`flex items-center justify-center bg-danger-soft text-danger text-xs ${className}`}>
        Failed to load
      </div>
    );
  }
  if (!src) {
    return <div className={`animate-pulse bg-surface-muted ${className}`} aria-label={`Loading ${alt}`} />;
  }
  return <img src={src} alt={alt} className={className} />;
}
